import { cleanDocxFootnotes } from './utils/cleanDocxFootnotes';
import { isDocxContent } from './utils/isDocxContent';

export const cleanDocx = (body: HTMLElement) => {
  if (!isDocxContent(body)) {
    return;
  }

  cleanDocxFootnotes(body);
};
